function toggleSearch() {
    const srchWrapper = document.getElementById("text-6");
    const megaMenuToggleElements = document.querySelectorAll(".mega-menu-toggle");
    let megaMenuWasOpened = false;

    // Close mega menus
    megaMenuToggleElements.forEach(function(el) {
      if (el.classList.contains('mega-menu-open')) {
        el.classList.remove("mega-menu-open");
        megaMenuWasOpened = true;
      }
    });

    // Toggle mobile search form
    if (megaMenuWasOpened) {
      srchWrapper.classList.contains('d-block') === false ? srchWrapper.classList.add("d-block") : null;
    } else {
      srchWrapper.classList.toggle('d-block');
    }

}

export {
  toggleSearch
};
